












































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import moment from 'moment';

import { STORE_KEY, store } from './_store';

// import TitleBar from '@/components/Elements/TitleBar.vue'
import draggable from 'vuedraggable'
import DeliveryInventoryForm from './DeliveryInventoryForm/DeliveryInventoryForm.vue';

@Component({
  computed: {
    ...mapState('ubic', [
      'actor'
    ]),

    ...mapState(STORE_KEY, [
      'vehicles', 'cityId', 'dataRefreshing'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'setVehicle', 'setEmployee', 'setTime',
      'print'
    ])
  },
  components: {
    draggable
  }
})
export default class DeliveryZoneMaster extends Vue {

  @Prop() zone!: any;

  vehicles!: any[];
  cityId!: any;
  dataRefreshing!: boolean;
  actor!: any;

  isOpen = false

  get targetDeals() {
    return this.zone.targetDeals
  }

  set targetDeals(value: any) {
    console.log('value', this.zone, value)
      // this.$store.commit('updateList', value)

      this.$store.dispatch(`${STORE_KEY}/moveDealBetweenZone`, { zone: this.zone, newItemList: value });
  }

  get reservesStatelabel() {
    const _reserves = this.zone.reserves.filter((res: any) => res.id);

    if (_reserves.length === 0) {
      return 'Тов. запас отсутствует';
    } else {
      return `Позиций тов. запаса: ${_reserves.length}`;
    }
  }
   allowSetCost(group_id: string) {
    return ['d:delivery_zone_groups:1', 'd:delivery_zone_groups:2', 'd:delivery_zone_groups:5'].includes(group_id)
  }

  onCardClick(dealId: string) {
    console.log(dealId)
  }

  openDocument(row: any) {
    this.$router.push({
      name: 'deal-details',
      params: {
        id: row.id
      }
    });
  }

  save() {
    this.$store.dispatch(`${STORE_KEY}/saveZone`, { zone: this.zone });
  }

  confirm() {
    this.$store.dispatch(`${STORE_KEY}/confirmZone`, { zone: this.zone });
  }

  setInventory() {

    // if(this.modal) {
    //   this.modal.close();
    // }

    this.$buefy.modal.open({
      component: DeliveryInventoryForm,
      props: {
        zone: this.zone
      },
      onCancel: () => {
        // this.$router.back()
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form',
      parent: this
    })
    // const dRef = this.dialog.open(DeliveryInventoryDialog, {
    //   panelClass: 'full-screen-dialog',
    //   maxWidth: 'none',
    //   position: {
    //     right: '0'
    //   },
    //   height: '100%',
    //   data: {
    //     zone: this.zone,
    //     products$: this.products$,
    //     variants$: this.variants$
    //   },
    // });

    // return dRef.afterClosed();
  }

  setDeliveryCost() {
    this.$buefy.dialog.prompt({
      message: `Стоимость маршрута`,
      inputAttrs: {
          type: 'number',
          placeholder: 'Цена',
          value: this.zone.instance_cost,
          // maxlength: 2,
          min: 0
      },
      confirmText: 'Сохранить',
      cancelText: 'Отмена',
      trapFocus: true,
      onConfirm: (value: any) => {
        this.$store.dispatch(`${STORE_KEY}/setInstanceCost`, { zone: this.zone, value });
      }
    })
    // const dRef = this.dialog.open(DeliveryCostDialog, {
    //   panelClass: 'full-screen-dialog',
    //   maxWidth: 'none',
    //   position: {
    //     right: '0'
    //   },
    //   height: '100%',
    //   data: {
    //     zone: this.zone
    //   },
    // });

    // return dRef.afterClosed();
  }

  // @todo ACTIONS
  // 'save', 'setDeliveryCost', 'confirm', 'print'

}
